import { Label } from '../Form/Fields/Label/Label'
import styles from './Toggle.module.scss'
import classNames from 'classnames'

interface ToggleProps {
    name?: string
    label?: string
    value: boolean
    onChange: (value: boolean) => void
    disabled?: boolean
    className?: string
    isColumn?: boolean
}

export const Toggle = ({
    name,
    label,
    value,
    onChange,
    disabled,
    className,
    isColumn,
}: ToggleProps) => {
    return (
        <div
            className={classNames(styles.wrapper, className, {
                [styles.withLabel]: Boolean(label),
                [styles.column]: isColumn,
            })}
        >
            <input
                type="checkbox"
                name={name}
                id={name}
                checked={value}
                className={styles.checkbox}
                disabled={disabled}
            />
            {label && <Label title={label} id={name || label} />}
            <div
                className={classNames(
                    styles.track,
                    { [styles.on]: value },
                    { [styles.disabled]: disabled }
                )}
                onClick={() => {
                    if (!disabled) {
                        onChange(!value)
                    }
                }}
            >
                <div className={styles.handle}></div>
            </div>
        </div>
    )
}
